import styled from '@emotion/styled';
import { lazy, Suspense, FC } from 'react';
import { Grid } from '@material-ui/core';
import theme from '../../theme';
import { flexibleLayoutContainer } from '../styleUtility/flexibleLayout';
import signInBackground from '../../assets/sign_in_background.mp4';

const SignInForm = lazy(() => import('../component/compound/SignInForm'));

interface Props {
  kaizenIdWithRedirectUrl: string;
  className?: string;
}

const ContentForSignedOut: FC<Props> = ({ kaizenIdWithRedirectUrl, className }) => {
  return (
    <Root className={className}>
      <Container container>
        <VideoContainer item lg={5}>
          <Video src={signInBackground} autoPlay loop playsInline />
        </VideoContainer>
        <FormContainer item lg={7} xs={12}>
          <Suspense fallback={<div />}>
            <SignInForm kaizenIdWithRedirectUrl={kaizenIdWithRedirectUrl} />
          </Suspense>
        </FormContainer>
      </Container>
    </Root>
  );
};

const Root = styled('div')({
  position: 'relative',
});

const Container = styled(Grid)({
  height: '100%',
});

const VideoContainer = styled(Grid)({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
});

const FormContainer = styled(Grid)(flexibleLayoutContainer({}), {
  height: '100%',
});

const Video = styled('video')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

export default ContentForSignedOut;
